export default {
    ALL_ID: '_all_',

    NEW_ID: '_new_',

    BUSINESS_LOGIC:
        {
            RESERVATION:
                {
                    STATUSES: {
                        PENDING: {
                            name: 'Pending',
                            color: 'tw-bg-blue-500',
                            fontColor: 'tw-text-white',
                        },
                        BOOKED: {
                            name: 'Booked',
                            color: 'tw-bg-green-500',
                            fontColor: 'tw-text-white',
                        },
                        CANCELLED: {
                            name: 'Cancelled',
                            color: 'tw-bg-red-500',
                            fontColor: 'tw-text-white',
                        },
                        DECLINED: {
                            name: 'Declined',
                            color: 'tw-bg-yellow-500',
                            fontColor: 'tw-text-white',
                        },
                    },
                },

            REQUEST:
                {
                    STATUSES: {
                        LIVE: {
                            name: 'Live',
                            color: 'tw-bg-green-500',
                            fontColor: 'tw-text-white',
                        },
                        NEW: {
                            name: 'New',
                            color: 'tw-bg-green-500',
                            fontColor: 'tw-text-white',
                        },
                        ARCHIVED: {
                            name: 'Archived',
                            color: 'tw-bg-yellow-500',
                            fontColor: 'tw-text-white',
                        },
                    },
                },
        },
};
